import "./App.css";
import "./components/darkmode.css";
import { BrowserRouter, Routes,   Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import KeyContextProvider from "./components/KeyContext";
import Login from "./views/Login";

import WeekReport from "./views/WeekReport";
import WeekReportMobil from "./views/WeekReportMobil";
import WeekReportMobile2 from "./views/WeekReportMobile2";

import Home from "./views/Home";

import DayPeriod from "./views/DayPeriode";
import DayPeriodMobil from "./views/DayPeriodeMobil";

import Configuration from "./views/Cofiguration";

import Dagens from "./views/Dagens";
import DagensMobil from "./views/DagensMobil";

import Messages from "./views/Messages";
import Header from "./components/header/Header";
import Reports from "./views/Reports";

import PeriodeSam from './views/PeriodeSam'
import PeriodeSamMobil from "./views/PeriodeSamMobil";

import Incidents from "./components/Incidents/Incidents";
import AdminIncidents from "./views/AdminIncidents";

import WorkPlan from "./views/WorkPlan";
import WorkplanMobil from "./views/WorkplanMobil";

import Program from './views/Program'

import FourWeeksReportMobil from "./views/FourWeeksReportMobil";
import Film from "./views/Film";
import ProtectdRoutes from "./utils/ProtectedRoutes";
import ProtectdProgramRoute from "./utils/ProtectedProgramRoute";
import ProtectdFilmRoute from "./utils/ProtectedFilmRoute";
// import { useNavigate } from "react-router-dom";

function App() {
  const key = sessionStorage.getItem("key");
  
  const o = document.querySelectorAll('option')
  const lenMax = 35
  o.forEach(e => {
    if (e.textContent.length > lenMax) {
      e.textContent = e.textContent.substring(0,lenMax) + '...';  
    }
    
  })
  // const navigate = useNavigate();
  let orgID = sessionStorage.getItem("orgID");
  const [rights, setRights] = useState([{}]);

   useEffect(() => {
        const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getaccessrights?Key=${key}&LoginNo=${orgID}`;
        if (key && orgID) {
          fetch(endpoint, {
            method: "GET",
            headers: {
              ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
            },
          })
            .then((res) => res.json())
            .then((result) => {
             //  console.log(result)
              
              setRights(result);
           // }
            });
        }
      }, [key, orgID]);

  let programRight = false
 rights.length && rights?.map((right) => {  
    if(right.name === 'ACC_PROGRAM') { 
      
      programRight = true   
      }
      return programRight    
   })

   let filmRight = false 
   rights.length && rights?.map((right) => {
     if(right.name === "ACC_EDITSYNOPSIS") {
      filmRight = true
     }
     return filmRight
   })
//console.log(filmRight, 'film right')

  return (
    <>
      <div className="App" >
        
        <KeyContextProvider>
          <BrowserRouter>
            <Routes>
             
              <Route path="/" element={<Login />}></Route>
             
             <Route element={<ProtectdRoutes />}>
              <Route exact path="/admin" element={ <Home /> }></Route>
             
              <Route path="/configuration" element={ <Configuration /> }></Route>
              
            

              <Route path="/messages" element={ <Messages/> }></Route>
             
              {
                filmRight === true ?  <Route path="/film" element = { <Film />}></Route> : 
                <Route element={<ProtectdFilmRoute />}>                 
                   <Route path="/film" element = { <Film />}> </Route>
                </Route>
              }


              { programRight === true ?  <Route path="/program" element={ <Program />}></Route> :  
               <Route element={<ProtectdProgramRoute />}>  
                   <Route path="/program" element={ <Program />}></Route>
              </Route>
              }
              <Route path="/reports" element={ <Reports/> }></Route>

              <Route path="/rapport" element={<WeekReport />}></Route>
              <Route path="/ugesrapport" element={ <WeekReportMobil />}></Route>
              <Route path="/ugesrapport2" element={ <WeekReportMobile2 />}></Route>

              <Route path="/dagsrapport" element={ <DayPeriodMobil />}></Route>
              <Route path="/dagsperiode" element={<DayPeriod />}></Route>

              <Route path ="/incidents" element={<AdminIncidents/>}></Route>

              <Route path="/dagensrapport" element={<Dagens />}></Route>
              <Route path="/dagenrapport" element={<DagensMobil />}></Route>

              <Route path ="/periode"  element={<PeriodeSam />}></Route>
              <Route path ="/perioder" element={<PeriodeSamMobil />}></Route>

              <Route path="/workplan" element={<WorkPlan />}></Route>
              <Route path="/workplans" element={<WorkplanMobil />}></Route>

              <Route path="/fourweeksreport" element={<FourWeeksReportMobil />}></Route>
              
            </Route>  
         </Routes>
          </BrowserRouter>
          
        </KeyContextProvider>

        
      </div>
    </>
  );
}

export default App;
